import difference from "lodash/difference";
import isString from "lodash/isString";
import map from "lodash/map";
import { INode } from "yfiles";
import { UNDO_ENGINE_AUTO_MERGE_TIME } from "../../constants";
import { updateGroupTable } from "../nodeRendering/updateGroupNodeTable";
export default (graphComponentRef, nodeIdsPinnedOutOfGroupRef) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return;
    graphComponentRef.current.graph.undoEngineEnabled = true;
    if (!graphComponentRef.current.graph.undoEngine)
        return;
    graphComponentRef.current.graph.undoEngine.mergeUnits = false;
    graphComponentRef.current.graph.undoEngine.autoMergeTime = UNDO_ENGINE_AUTO_MERGE_TIME;
    const undoRedoClicked = () => {
        var _a, _b;
        (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.selection.clear();
        if ((_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.graph) {
            graphComponentRef.current.graph.labels.forEach(label => {
                var _a;
                if (!(label.tag && isString(label.tag) && label.owner && label.owner instanceof INode))
                    return;
                const groupGraphTag = (_a = label.owner) === null || _a === void 0 ? void 0 : _a.tag;
                if (!groupGraphTag || !groupGraphTag.GroupId)
                    return;
                if (nodeIdsPinnedOutOfGroupRef) {
                    nodeIdsPinnedOutOfGroupRef.current[groupGraphTag.GroupId] = difference(nodeIdsPinnedOutOfGroupRef.current[groupGraphTag.GroupId] || [], map(groupGraphTag.Nodes, "NodeId"));
                }
                const wrapper = document.querySelector(`#${label.tag}`);
                wrapper && updateGroupTable(wrapper, groupGraphTag.Nodes);
            });
        }
    };
    graphComponentRef.current.graph.undoEngine.addUnitUndoneListener(undoRedoClicked);
    graphComponentRef.current.graph.undoEngine.addUnitRedoneListener(undoRedoClicked);
};
